import { useMemo } from "react"
import { mapTableData } from "../helpers"
import { useTableContext } from "../provider"

export const useRowsData = () => {

  const ctx = useTableContext()

}